<template>
    <div class="bg-gray-100 dark:bg-dark-800 rounded-lg divide-y divide-gray-300 dark:divide-gray-700">
        <!-- Header -->
        <div class="px-4 py-2 bg-gray-200 dark:bg-dark-700 rounded-t-lg">
            <h3 class="text-sm font-medium text-gray-700 dark:text-gray-200">Ringkasan Pesanan</h3>
        </div>

        <!-- Items List -->
        <div class="divide-y divide-gray-300 dark:divide-gray-700 max-h-48 overflow-y-auto">
            <div v-for="item in sortedOrderItems || []" :key="item.id"
                class="px-4 py-2 hover:bg-gray-200 dark:hover:bg-dark-700 transition-colors duration-150" :class="{
                    'bg-gray-200 dark:bg-dark-700': item.status == 'canceled'
                }">
                <div class="flex items-start justify-between">
                    <!-- Item Details -->
                    <div class="flex-grow">
                        <h4 class="text-sm font-medium" :class="{
                            'text-gray-500': item.status == 'canceled',
                            'text-gray-900 dark:text-gray-100': item.status != 'canceled'
                        }">
                            {{ item.name }}
                        </h4>
                        <div class="mt-1 items-center space-x-2" v-if="!item.complimentary">
                            <span class="text-sm" :class="{
                                'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                'text-gray-500': item.status == 'canceled'
                            }">
                                {{ item.status == 'canceled' ? '-' : '' }} {{ item.quantity }}x
                            </span>
                            <span class="text-sm" :class="{
                                'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                'text-gray-500': item.status == 'canceled'
                            }">
                                {{ formatRupiah(item.complimentary ? 0 : item.price) }}
                            </span>
                            <div v-if="item.discount_applied && !item.complimentary && item.globalDiscountAmount">
                                <span class="text-sm" :class="{
                                    'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                    'text-gray-500': item.status == 'canceled'
                                }">
                                    Global Discount: -{{ formatRupiah(item.globalDiscountAmount * item.quantity) }}
                                </span>
                            </div>
                            <div v-if="item.tax_applied && !item.complimentary && item.taxAmount">
                                <span class="text-sm" :class="{
                                    'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                    'text-gray-500': item.status == 'canceled'
                                }">
                                    Tax: {{ item.status == 'canceled' ? '-' : '+' }} {{ formatRupiah(item.taxAmount) }}
                                </span>
                            </div>
                            <div v-if="item.service_charge_applied && !item.complimentary && item.serviceChargeAmount">
                                <span class="text-sm" :class="{
                                    'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                    'text-gray-500': item.status == 'canceled'
                                }">
                                    SC: {{ item.status == 'canceled' ? '-' : '+' }} {{
                                    formatRupiah(item.serviceChargeAmount) }}
                                </span>
                            </div>
                        </div>
                        <div class="mt-1 flex items-center space-x-2" v-else>
                            <span class="text-sm" :class="{
                                'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                'text-gray-500': item.status == 'canceled'
                            }">
                                {{ item.status == 'canceled' ? '-' : '' }} {{ item.quantity }}x
                            </span>
                            <span class="text-sm" :class="{
                                'text-gray-600 dark:text-gray-400': item.status != 'canceled',
                                'text-gray-500': item.status == 'canceled'
                            }">
                                (Complimentary)
                            </span>
                        </div>
                    </div>

                    <!-- Price Details -->
                    <div class="text-right">
                        <div v-if="item.discount > 0" class="flex flex-col items-end">
                            <span class="text-xs text-red-500">
                                Diskon {{ formatRupiah(item.complimentary ? 0 : item.discount) }}
                            </span>
                            <span class="text-xs text-gray-400 dark:text-gray-500 line-through">
                                {{ formatRupiah(item.complimentary ? 0 : item.price * item.quantity) }}
                            </span>
                        </div>
                        <span class="text-sm font-medium" :class="{
                            'text-gray-900 dark:text-gray-100': item.status != 'canceled',
                            'text-gray-500': item.status == 'canceled'
                        }">
                            {{ item.status == 'canceled' ? '-' : '' }} {{ formatRupiah((item.complimentary ? 0 :
                                item.price * item.quantity) -
                                (item.discount || 0)) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Summary Footer -->
        <div v-if="items?.length > 0" class="px-4 py-3 bg-gray-200 dark:bg-dark-700 rounded-b-lg">
            <!-- <div class="flex justify-between items-center">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Total Item</span>
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ totalItems }} menu</span>
            </div> -->
            <div class="flex justify-between items-center mt-1">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Total Kuantitas</span>
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ totalQuantity }} pcs</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { formatRupiah } from '@/helpers/formatRupiah';

    export default {
        name: 'ListItemPayment',
        props: {
            items: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            sortedOrderItems() {
                return [...this.items].sort((a, b) => a.id - b.id);
            },
            totalQuantity() {
                console.log("items", this.items);
                if (!this.items) return 0;
                return this.items.reduce((sum, item) => sum + ((item?.quantity || 0) * (item.status == 'canceled' ? -1 : 1)), 0);
            }
        },
        methods: {
            formatRupiah
        }
    }
</script>